import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { FC } from 'react';
import BrandBookFormCloseButton from '@/components/BrandBookFormCloseButton';
import BrandBookFormContainer from '@/components/BrandBookFormContainer';
import css from './style.module.scss';
interface Props {
  onClose: () => void;
}
const BrandBookFormSend: FC<Props> = t0 => {
  const $ = _c(10);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = <BrandBookFormCloseButton onClose={onClose} />;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className={css.title}>You Are all set</p>;
    t3 = <p className={css.text}>Your Q–Brandbook is on its way</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={css.imageContainer}><Image width={370} height={337} className={css.image} src="/assets/images/brand-book/chub-brown.png" alt="" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onClose) {
    t5 = <button className={css.button} onClick={onClose}>Close</button>;
    $[5] = onClose;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t1 || $[8] !== t5) {
    t6 = <BrandBookFormContainer>{t1}{t2}{t3}{t4}{t5}</BrandBookFormContainer>;
    $[7] = t1;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export default BrandBookFormSend;